import { ModalItemData } from '../../data/ModalItemData'
import styles from './ModalItem.module.css'

interface ModalItemProps {
    isHeader: boolean
    data: ModalItemData
}

export default function ModalItem({ isHeader, data }: ModalItemProps) {
    return (
        <div>
            <h3
                className={`${isHeader ? styles.titleHeader : styles.title}`}
                dangerouslySetInnerHTML={{ __html: data.summary }}
            />
            <div className={styles.content}>
                <p className={styles.paragraph} dangerouslySetInnerHTML={{ __html: data.body }} />
            </div>
        </div>
    )
}
